import qs from "qs";

// Valid params in query string - to avoid putting whole configure object in query string
const validParams = ["page", "_page", "query", "refinementList"];

const getPage = () => {
  // Use underscore as parameter as "page" is a reserved word in WP
  let page = getParamValue("_page");
  // console.log("getPage", page);
  if (!isNaN(page) && +page > 1) {
    return +page;
  }
  return 1;
};

const getParamValue = (param) => {
  const queryParams = qs.parse(window.location.search.slice(1), { arrayFormat: "repeat" });
  // console.log(getParamValue, queryParams);
  const val = queryParams && queryParams[param];
  if (val && !isNaN(val)) {
    return +val;
  }
  return val;
};

// Create querystring of searchstate
const createQS = (state, additionalFilters) => {
  // Get attributes that are to be included in search string
  const { refinementList, page, query = "" } = state;
  const queryString = {};
  // console.log("createQS query", query);
  if (query.length > 0) {
    queryString["query"] = query.trim();
  }
  if (refinementList && Object.entries(refinementList).filter((c) => c[1] > "").length) {
    queryString["refinementList"] = refinementList;
  }

  // lastly, add page, if it is a number and there are some search params, else page=! will be automatically
  queryString["_page"] = page;

  const cleanQuery = Object.entries(queryString).reduce((a, [k, v]) => {
    return v === "" ? a : ((a[k] = v), a);
  }, {});
  //console.log("createQS cleanQuery", cleanQuery);

  const retval = Object.keys(cleanQuery).length === 0 ? "" : `?${qs.stringify(cleanQuery, { arrayFormat: "brackets" })}`;
  // console.log("createQS retval", retval);
  return retval;
};

// const validParamNames = ["page", "query", "refinementList", "debug"];

const urlToSearchState = ({ search }) => {
  const queryParams = qs.parse(search.slice(1), { arrayFormat: "repeat" });
  // Pick out the stuff we want in query string - remove empty string and non valid params
  // console.log('queryParams: ', queryParams)
  const params = Object.entries(queryParams).reduce((a, [k, v]) => {
    return validParams.indexOf(k) === -1 || v === "" ? a : ((a[k] = v), a);
  }, {});

  // const validParams = Object.keys(params).filter((v) => validParamNames.includes(v));

  const retval = {
    query: "", // add query if not present
    refinementList: queryParams?.refinementList ? queryParams.refinementList : {},
    page: getPage(),
    _page: getPage(),
    ...params,
  };
  return retval;
};

const searchStateToUrl = (path, searchState) => {
  const state = searchState ? createQS(searchState) : "";
  return path + state;
};

// Single filter params
// ===================================================
// const createURL = (state) => `?${qs.stringify(state)}`;
// const searchStateToUrl = (location, searchState) => (searchState ? `${createURL(searchState)}` : "");
// const urlToSearchState = (location) => qs.parse(location.search.slice(1));
// export { createURL, searchStateToUrl, urlToSearchState };

export { createQS, searchStateToUrl, urlToSearchState, getParamValue };
